<template>
  <div class="box-tools pull-right">
    <button
      type="button"
      class="btn btn-box-tool btn-collapse"
      data-widget="collapse"
    >
      <i class="fa fa-minus" />
    </button>
    <button
      type="button"
      class="btn btn-box-tool btn-remove"
      data-widget="remove"
    >
      <i class="fa fa-times" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'CashHeroBoxToolsAction',
  mounted () {
    this.clearEventHandlers([
      '.btn-collapse',
      '.btn-remove'
    ])

    $(document).on('click', '.btn-collapse', function () {
      $(this).parent().parent().parent().toggleClass('collapsed-box')
    })

    $(document).on('click', '.btn-remove', function () {
      $(this).parent().parent().parent().remove()
    })
  },
  destroyed () {
    this.clearEventHandlers([
      '.btn-collapse',
      '.btn-remove'
    ])
  }
}
</script>

<style scoped>

</style>
